import React, { Component } from "react";
import { UserPhoto } from "../../../common/userPhoto/userPhoto";
import { Row, Col, Input, Form } from 'antd';

const FormItem = Form.Item;

export class ChurchPastorFields extends Component {
  constructor(props) {
    super(props);
    this.state = { type: this.props.type || 'senior_pastor' };
  }

  get pastorIndex() {
    return this.state.type === "pastors" ? `[${this.props.index}]` : "";
  }

  onPhotoLoad = (photoDataUri) => {
    const key = `${this.state.type}${this.pastorIndex}`;
    this.props.form.setFieldsValue({ [key]: { photo_data_uri: photoDataUri } });
  };

  onPhotoRemove = () => {
    const {setFieldsValue} = this.props.form;
    setFieldsValue({ [this.state.type]: { photo_data_uri: '' } });
  };

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <Row>
        <Col lg={7} xl={5} xxl={3} xs={24} className="profile-page__sider">
          <div className="profile-page__photo-block">
            <FormItem className="profile-form__item--nomargin">
              {getFieldDecorator(`${this.state.type}${this.pastorIndex}.photo_data_uri`)(
                <UserPhoto onPhotoLoad={this.onPhotoLoad} onPhotoRemove={this.onPhotoRemove} />
              )}
            </FormItem>
          </div>
        </Col>
        <Col xs={{span: 24}} lg={{offset: 1, span: 16}}>
          <FormItem label="Email (app username)">
            {getFieldDecorator(`${this.state.type}${this.pastorIndex}.email`, {
              rules: [
                { required: true, message: 'Please specify Pastor email' },
                { type: "email", message: 'Pastor email is not valid' }
              ],
            })(
              <Input placeholder="Pastor email" />
            )}
          </FormItem>
          <FormItem label="Name">
            {getFieldDecorator(`${this.state.type}${this.pastorIndex}.name`, {
              rules: [
                { required: true, message: 'Please specify Pastor name' }
              ],
            })(
              <Input placeholder="Pastor name" />
            )}
          </FormItem>
          <FormItem label="Department">
            {getFieldDecorator(`${this.state.type}${this.pastorIndex}.department`)(
              <Input placeholder="Input text" />
            )}
          </FormItem>
          <FormItem label="Phone #">
            {getFieldDecorator(`${this.state.type}${this.pastorIndex}.phone`)(
              <Input placeholder="Phone #" />
            )}
          </FormItem>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/form/churchPastorFields.js